export default __webpack_public_path__ + "static/media/trr-event-coffee.f941f469.png";